import React, { memo } from 'react';
import CompleteCellContentModal from '../../datagrid/CompleteCellContentModal';
import Tooltip from '../Tooltip';

import { project_report_edit_report_path } from '~/routes';

export const valueGetter = (params) => {
  params.data ||= {};
  const val = (params.data[params.colDef.field] || {});
  if (val['type'] == 'input') {
    return I18n.t('user_input')
  } else if (val['type'] == 'data_capture' || val['type'] == 'form_capture') {
    return I18n.t('data_capture')
  } else if (!val['type']) {
    return ""
  } else {
    return I18n.t('invalid_value')
  }
};

export const filterGetter = (params) => {
  return (params.data[params.colDef.field] || {})["id"]
}

const MonitoringReportLinkCellRenderer = memo((params) => {
  const value = (params.data || {})[params.colDef.field] || {};

  const getLabel = (data) => {
    if (data.type == 'input')
      return I18n.t('user_input');
    else if (['data_capture', 'form_capture'].includes(data.type))
      return I18n.t('data_capture');
    else if (data.type == 'import')
      return I18n.t('excel_import_row_idx', {xls_index: data.excel_row_index});
    else if (data.type == 'bulk_edit')
      return I18n.t('bulk_edit');
    else if (!data.type)
      return '';

    return I18n.t('invalid_value');
  }

  const getLink = (data) => {
    const {type, project_id, monitoring_report_id, project_report_id, attachment_path} = data;
    const label = getLabel(data);

    if (type == 'import') {
      return <Tooltip title={I18n.t('click_to_download_original_file')}>
        <a href={attachment_path}>{label}</a>
      </Tooltip>

    } else if (project_id && monitoring_report_id && project_report_id) {
      return <a href={project_report_edit_report_path({project_id: project_id, report_id: monitoring_report_id, project_report_id: project_report_id})}>{label}</a>
    }
    return label;
  }

  return (
    value.history ?
      <CompleteCellContentModal
        cellContent={
          <ol>
            {value.history.map((v, i) => <li key={i}>{I18n.t(i == 0 ? 'row_created' : 'row_updated')} - {getLink(v)}</li>)}
            <li>{I18n.t('row_updated')} - {getLink(value)} ({I18n.t('current_version')})</li>
          </ol>
        }
        cellLabel={
          <div>
            {getLabel(value)}
            <span style={{float: 'right'}}>
              <span className='tag tag-info'>{value.history.length}</span> <i className='fa-solid fa-clock-rotate-left'></i>
            </span>
          </div>}
        cellIdentifier={`${params.data.row_id}-${params.original.id}`}
        title={params.colDef.headerName}
      />
      : getLink(value)
  );
});

export default MonitoringReportLinkCellRenderer;